import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CalendarEvent } from 'angular-calendar';

import { MatColors } from '@fuse/mat-colors';

import { EmployeeCalendarEventModel } from '../event.model';

@Component({
    selector: 'calendar-event-form-dialog',
    templateUrl: './event-form.component.html',
    styleUrls: ['./event-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class EmployeeCalendarEventFormDialogComponent {
    action: string;
    event: EmployeeCalendarEventModel;
    eventForm: FormGroup;
    dialogTitle: string;
    presetColors = MatColors.presets;
    eventTypes: any;
    company: any;

    /**
     * Constructor
     *
     * @param {MatDialogRef<EmployeeCalendarEventFormDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public matDialogRef: MatDialogRef<EmployeeCalendarEventFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder
    ) {
        this.event = _data.event;
        this.action = _data.action;
        this.eventTypes = _data.types;
        this.company = _data.company;

        console.log(this.eventForm, this.eventTypes);

        if (this.action === 'edit') {
            this.dialogTitle = this.event.title;
        }
        else {
            this.dialogTitle = 'Add non working day/days';
            this.event = new EmployeeCalendarEventModel({
                start: _data.date,
                end: _data.date
            });
        }

        this.eventForm = this.createEventForm();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    // convenience getter for easy access to form fields
    get f(): any { return this.eventForm.controls; }

    getGroup(type): string {
        let retVal = '';
        Object.keys(this.eventTypes).forEach(group => {
            if (this.eventTypes[group].indexOf(type) > -1) {
                retVal = group;
            }
        });
        return retVal;
    }

    nextDay(): any {
        const date = new Date(this.eventForm.get('start').value);
        return new Date(date.setDate(date.getDate() + 1));
    }

    /**
     * Create the event form
     *
     * @returns {FormGroup}
     */
    createEventForm(): FormGroup {
        return new FormGroup({
            id: new FormControl(this.event.id),
            type: new FormControl(this.event.type),
            typeGroup: new FormControl(''),
            title: new FormControl(this.event.title),
            start: new FormControl(this.event.start),
            end: new FormControl(this.event.end),
            days: new FormControl(this.event.days),
            isRecurring: new FormControl(this.event.isRecurring),
            frequenceTypeOfRecurring: new FormControl(this.event.frequenceTypeOfRecurring || 'day'),
            endOfRecurring: new FormControl(this.event.endOfRecurring || null),
            // allDay: new FormControl(this.event.allDay),
            // color: this._formBuilder.group({
            //     primary: new FormControl(this.event.color.primary),
            //     secondary: new FormControl(this.event.color.secondary)
            // }),
            // meta:
            //     this._formBuilder.group({
            //         location: new FormControl(this.event.meta.location),
            //         notes: new FormControl(this.event.meta.notes)
            //     })
        });
    }
}
